import { Checkbox } from '@/components/ui/checkbox';
import { CheckboxBlock as ICheckboxBlock } from '@/lib/types';
import BaseInputBlock from './base-input-block';
import { useFillableBlockResponse } from './common';

interface Props {
  block: ICheckboxBlock;
}

export default function CheckboxBlock({ block }: Props) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });

  return (
    <BaseInputBlock block={block}>
      <Checkbox
        id={`block-${block.referenceID}`}
        checked={payload?.value}
        size='sm'
        onCheckedChange={(e) => updatePayload({ value: e.checked })}
      >
        {block.field_name}
      </Checkbox>
    </BaseInputBlock>
  );
}
